interface SortItem {
  name: string;
  isDefault?: boolean | null;
}

export const sortBrands = (a: SortItem, b: SortItem) => {
  if (a.isDefault) {
    return -1;
  }
  if (b.isDefault) {
    return 1;
  }

  return a.name.localeCompare(b.name);
};
